import { Map } from 'immutable';
import { 
	LOAD_ALL_DISCOVER_ELEMENTS,
	SELECTED_DISCOVER_ARTICLE,
	LOAD_SINGLE_ARTICLE, 
	UNLOAD_SINGLE_ARTICLE,
	FILTER_CATEGORY_NAME
} from '../actions/discover.actions';
import { CategoryFilterNames } from "../config-data/category-filters";


const initialState = Map({
	dataIsLoading: true,
	articleIsLoaded: false,
	selectedArticle: {},
	discoverData: [],
	discoverFilters: [
		{ filterId: CategoryFilterNames.BARS, filterDisplayName: 'Bars', filterIsActive: true },
		{ filterId: CategoryFilterNames.CAFES, filterDisplayName: 'Cafés', filterIsActive: true },
		{ filterId: CategoryFilterNames.RESTAURANTS, filterDisplayName: 'Restaurants', filterIsActive: true },
		{ filterId: CategoryFilterNames.CLUBS, filterDisplayName: 'Clubs', filterIsActive: true },
		{ filterId: CategoryFilterNames.SHOPS, filterDisplayName: 'Shops', filterIsActive: true },
		{ filterId: CategoryFilterNames.AUSFLUEGE, filterDisplayName: 'Ausflüge', filterIsActive: true },
		{ filterId: CategoryFilterNames.SPORT, filterDisplayName: 'Sport', filterIsActive: true },
		{ filterId: CategoryFilterNames.KULTUR, filterDisplayName: 'Kultur', filterIsActive: true }
	]
});

export default function (state = initialState, action) {
	switch(action.type) {
		case LOAD_ALL_DISCOVER_ELEMENTS:
			state = state
				.set('discoverData', action.payload.discoverData)
				.set('dataIsLoading', false);
			return state;

		// TODO: write tests for this.
		case LOAD_SINGLE_ARTICLE:
			state = state
				.set('selectedArticle', action.payload.articleData)
				.set('articleIsLoaded', true);
			return state;

		// TODO: Write tests for this.
		case SELECTED_DISCOVER_ARTICLE:
			state = state
				.set('selectedArticle', action.payload.selectedArticle)
				.set('articleIsSelected', true);
			return state;

		case UNLOAD_SINGLE_ARTICLE:
			state = state
				.set('articleIsLoaded', false)
				.set('selectedArticle', {});
			return state;
			
		case FILTER_CATEGORY_NAME:
			state = state
				.set('discoverData', action.payload.filteredDiscoverItems)
				.set('discoverFilters', action.payload.updatedFilterItems)
			return state;

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/discover.reducer.js